export const MODULE_ID = 'axp-loyalty-experience-root';
export const LOYALTY_MODULE_CONFIG = 'loyaltyModuleConfig';
